<template lang="pug">
  BNavbar#navbar(
    :fixed-top="true"
    type="is-white"
    transparent=true
    centered=true
  )
    template(slot="brand")
      BNavbarItem(v-if="!isInsideIframe"
        tag="router-link"
        :to="{ path: '/' }"
      )
        img(:src="determineLogo")
      template(slot="burger")
        a.navbar-burger(
          role="button"
          aria-label="menu"
          aria-expanded="false"
        )
          span(aria-hidden="true")
          span(aria-hidden="true")
          span(aria-hidden="true")
    template(slot="menu" is-active)
    template(slot="start")
      template(v-for="routeObject in mainRoutes")
        BNavbarItem(
          :key="routeObject.name"
          tag="router-link"
          :to="routeObject.path"
        )
          BTooltip(
            :label="routeObject.meta.viewTitle"
            type="is-light"
            animated=false
            position="is-bottom"
            size="is-small"
          )
            WtSvgIcon.has-margin-right-1(
              :icon="routeObject.meta.linkIcon"
              width="20px"
              height="20px"
            )
          span(v-if="isMobile") {{ routeObject.meta.viewTitle }}
      BNavbarItem(v-if="customButtonOn")
        BTooltip(
          :label="customButtonText"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          CustomButton
        span(v-if="isMobile") {{ customButtonText }}
      BNavbarItem(
        :key="memberSettingsRoutes.name"
        tag="router-link"
        :to="memberSettingsRoutes.path"
      )
        BTooltip(
          :label="memberSettingsRoutes.meta.viewTitle"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          WtSvgIcon.has-margin-right-1(
            :icon="memberSettingsRoutes.meta.menuIcon"
            width="20px"
            height="20px"
          )
        span(v-if="isMobile") {{ memberSettingsRoutes.meta.viewTitle }}
      BNavbarItem(
          :key="messageRoutes.name"
          tag="router-link"
          :to="messageRoutes.path"
        )
          BTooltip(
            :label="messageRoutes.meta.viewTitle"
            type="is-light"
            animated=false
            position="is-bottom"
            size="is-small"
          )
            .counter.tag.is-blue.is-rounded(v-if="messageCount > 0") {{ messageCount }}
            WtSvgIcon.has-margin-right-1(
              :icon="messageRoutes.meta.linkIcon"
              width="20px"
              height="20px"
            )
          span(v-if="isMobile") {{ messageRoutes.meta.viewTitle }}
      BNavbarItem(
        :key="memberQuestionsRoutes.name"
        tag="router-link"
        :to="memberQuestionsRoutes.path"
      )
        BTooltip(
          :label="memberQuestionsRoutes.meta.viewTitle"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          WtSvgIcon.has-margin-right-1(
            :icon="memberQuestionsRoutes.meta.menuIcon"
            width="20px"
            height="20px"
          )
        span(v-if="isMobile") {{ memberQuestionsRoutes.meta.viewTitle }}
      BNavbarItem( v-if="isAdmin"
        :key="adminRoutes.name"
        tag="router-link"
        :to="adminRoutes.path"
      )
        BTooltip(
          :label="adminRoutes.meta.viewTitle"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          WtSvgIcon.has-margin-right-1(
            :icon="adminRoutes.meta.menuIcon"
            width="20px"
            height="20px"
          )
        span(v-if="isMobile") {{ adminRoutes.meta.viewTitle }}
      BNavbarItem( v-if="isWtAdmin"
        :key="adminSuperRoutes.name"
        tag="router-link"
        :to="adminSuperRoutes.path"
      )
        BTooltip(
          :label="adminSuperRoutes.meta.viewTitle"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          WtSvgIcon.has-margin-right-1(
            icon="blue-shoe"
            width="20px"
            height="20px"
          )
        span(v-if="isMobile") {{ adminSuperRoutes.meta.viewTitle }}
      BNavbarItem(v-if="$auth.user().showGetStartedGuide && $auth.user().isProgramAdmin")
        BTooltip(
          label="Get Started"
          type="is-light"
          animated=false
          position="is-bottom"
          size="is-small"
        )
          WtButton.get-started-guide(
            is-rounded
          )
            BIcon.has-margin-right-1(slot="icon" icon="check-circle-outline" type="is-dark")
    template(slot="end")
      span(v-if="!isInsideIframe")
        BNavbarDropdown(
          right
          :label="$auth.user().username"
        )
          BNavbarItem(@click="logout")
            | Logout
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import CustomButton from "@@/NavBar/CustomButton";

export default {
  name: "TheNavBar",

  components: {
    WtSvgIcon,
    CustomButton
  },

  computed: {
    ...mapGetters(["isMobile"]),
    ...mapGetters("authMember", ["isAdmin", "isWtAdmin"]),
    ...mapGetters("program", [
      "coreProgramMeta",
      "isTeamsFeatureOn",
      "isPointsFeatureOn",
      "programSettingsCopy",
      "isProTier"
    ]),
    ...mapGetters("pages", ["isPageLoaded"]),
    ...mapGetters("members", ["messageCount", "messages"]),

    loadMessages() {
      return (
        this.isPageLoaded("MyDashboard") || this.$route.name !== "MyDashboard"
      );
    },

    customButtonOn() {
      return !!(this.isProTier && this.coreProgramMeta.customNavbarButton);
    },

    mentalWellnessEnabled() {
      return this.programSettingsCopy.mentalWellnessEnabled ? 1 : 0;
    },

    adminRoutes() {
      const index = this._.findIndex(this.$router.options.routes, {
        name: "Admin"
      });

      return this.$router.options.routes[index];
    },

    adminSuperRoutes() {
      const index = this._.findIndex(this.$router.options.routes, {
        name: "AdminSuper"
      });

      return this.$router.options.routes[index];
    },

    memberSettingsRoutes() {
      const index = this._.findIndex(this.$router.options.routes, {
        name: "MemberSettings"
      });

      return this.$router.options.routes[index];
    },

    messageRoutes() {
      const index = this._.findIndex(this.$router.options.routes, {
        name: "Messages"
      });
      return this.$router.options.routes[index];
    },

    memberQuestionsRoutes() {
      const index = this._.findIndex(this.$router.options.routes, {
        name: "MemberQuestions"
      });

      return this.$router.options.routes[index];
    },

    mainRoutes() {
      let routes = this._.filter(this.$router.options.routes, {
        meta: {
          viewLink: true
        }
      });

      if (!this.mentalWellnessEnabled) {
        this._.remove(routes, { name: "Plan" })[0];
      }

      // TODO if isCoreTier showTeamsUpgradeModalThingyWhateverTheDesignIs
      // note: teams can only be toggled on by an admin in Engage/Thrive via the admin settings
      if (!this.isTeamsFeatureOn) {
        this._.remove(routes, { name: "Teams" })[0];
      }
      // note: points can only be toggled on by an admin via the admin settings
      if (!this.isPointsFeatureOn) {
        this._.remove(routes, { name: "Points" })[0];
      }

      if (
        !this._.get(this.coreProgramMeta, "organizationsOn", false) ||
        !this.isProTier ||
        !this.isAdmin
      ) {
        this._.remove(routes, { name: "ChooseOrganization" })[0];
      }

      let _this = this;
      this._.forEach(routes, function(route) {
        if (route.name === "ChooseOrganization") {
          _this._.set(
            route,
            "meta.viewTitle",
            _this._.get(
              _this.coreProgramMeta,
              "organizationsName",
              "Organization"
            )
          );
        }
      });
      return routes;
    },

    determineLogo() {
      // if the program does not have custom logo (only WellPro can)
      // return Be Well logo
      if (!this.coreProgramMeta.programLogo) {
        return require("@/assets/icons/be-well-logo.svg");
      } else {
        return this.coreProgramMeta.programLogo;
      }
    },

    customButtonText() {
      const text = this.coreProgramMeta.customButtonText;
      return text.charAt(0).toUpperCase() + text.slice(1);
    },

    isInsideIframe() {
      //wellpro has a terryberryCompanyUrl - but needs to run outside iframe for demo purposes
      //wellpro programId = 3691
      if (this.coreProgramMeta.id == 3691) {
        return false;
      } else {
        return !!this._.get(this.coreProgramMeta, "terryberryCompanyUrl", "");
      }
    }
  },

  mounted() {
    this.$gtag.config({
      user_id: this.$auth.user().id
    });

    this.fetchMessages({ memberId: this.$auth.user().id });
  },

  methods: {
    ...mapActions(["resetState"]),
    ...mapActions("members", ["fetchMessages"]),

    logout() {
      this.$gtag.config({
        user_id: null
      });

      this.$auth.logout();
      this.resetState();
    }
  }
};
</script>

<style lang="sass" scoped>
#navbar
  .tag
    height: 14px
    width: 14px
    position: absolute
    margin-right: 13px
</style>
